export default __webpack_public_path__ + "static/news-section-ice-image-4448f1c237327ed34328418b96f4d3e6.webp";